import React, { Component } from 'react';

import InputMask from 'react-input-mask';

import Header from '../common/header';

import Activation from '../activation';

import InvalidLink from '../activation/invalid-link';

import config from '../../config';

import axios from 'axios';

import queryString from 'query-string';

import { Redirect } from 'react-router-dom';

class Home extends Component {

    constructor(props) {

        super(props);

        this.state = {
            hideVerified: false,
            hideLooksGood: false,
            linkValid: false,
            showActivation: false,
            keyReady: false,
            showActivationCode : false,
            activationCodeValid : true,

            activation: {
                monitor_token: '',
                serial_no: '',
                purchaser_email: '',
                serial_regex: '',
            }

        };

        this.qs = queryString.parse(window.location.search);
        this.handleActivationCodeChange = this.handleActivationCodeChange.bind(this);
        this.handleActivationCodeSubmitBtn = this.handleActivationCodeSubmitBtn.bind(this);
        this.retryBtn = this.retry.bind(this);

    }

    retry() {

        if (this.state.activationCodeValid == false) {
            document.getElementById("activationCodeInput").removeAttribute('readonly');
            this.setState({
                activationCodeValid : true
            })
            document.getElementById("activationCodeInput").focus();

        }


    }
    handleActivationCodeSubmit(event) {
        event.preventDefault();
    }
    handleActivationCodeChange(event) {
        this.setState({ activationCode: event.target.value });



    }

    handleActivationCodeSubmitBtn() {
        document.getElementById("activationCodeInput").setAttribute('readonly', true);
        let originalActivationCode = this.state.activationCode.replace(/-/g, '').replace(/_/g, '');

        if (originalActivationCode.length == 16) {
            this.setState({originalActivationCode: originalActivationCode})
        }
        var originalLicense = originalActivationCode;
        if(originalLicense && originalLicense.length == 16)
        {
            this.validateActivationCode(originalLicense);

        }else {
            this.setState({
                activationCodeValid : false
            })
        }
    }

    validateActivationCode(value) {
        this.setState({
            hideVerified: false,
            hideLooksGood: true,
            linkValid: true,
            showActivationCode:false
        });
    this.setState({

        activationCodeInputClass: 'form-control linear-background',
    });

    document.getElementById("activationCodeInput").setAttribute('readonly', true);

    axios.get(`${config.baseUrl}`, {
        params: {
            action: 'getactivationkeybyactivationcode',
            activation_code: value.toUpperCase()
        }
    }).then((e) => {

        this.setState({
            activationCodeInputClass: 'form-control'
        });

        const response = e.data;

        if (response.status === 'success') {

            const data = response.data || {};

            if (data.activation_status == 'success') {
                let customer_email = config.getVerifiedEmail();
                this.qs.key = data.activation_key
                this.validateActivationKey(customer_email)
            } else if (data.activation_status == 'error') {
                this.setState({
                    hideVerified: true,
                    hideLooksGood: true,
                    linkValid: false
                });

            }

            return;

        }

        this.setState({ licenseValid: 'error', licenseInputLabel: this.licenseLabels.error, licenseErrorMessage: this.licenseLabels.errorMessage });

    });
}

    validateActivationKey(customer_email) {

        axios.get(`${config.baseUrl}`, {
            params: {
                action: 'getverifylicensepurchase',
                activation_key: this.qs.key || '',
                customer_email: customer_email,
            }
        }).then((e) => {

            const response = e.data;

            if (response.status == 'success') {

                const data = response.data || {};

                config.setPurchaserEmail(data.purchaser_email || '');
                config.setLicenseName(data.license_item_display_name || '');
                config.setLicenseItemName(data.license_item_name || '');

                if (data.activation_response === 'Looks good') {

                    this.setState({
                        hideVerified: true, linkValid: true,hideLooksGood: false
                    });


                    config.setActivation({
                        monitor_token: data.monitor_token,
                        serial_no: data.serial_no,
                        purchaser_email: data.purchaser_email,
                        serial_regex: data.serial_regex,
                    });


                    setTimeout(() => {

                        this.setState({
                            hideLooksGood: true,

                        });
                        if(this.qs.key === null || this.qs.key === undefined || this.qs.key === '')
	                    {
                            this.setState({
                                showActivation: false
                            })
                        } else {
                            this.setState({
                                showActivation: true
                            })
                        }

                    }, 2000);

                } else if (data.activation_response === 'Not Valid') {
                    this.setState({
                        hideVerified: true,
                        hideLooksGood: true,
                        linkValid: false
                    });
                } else if (data.activation_response === 'Already used') {
                    this.setState({
                        alreadyConsumed: true
                    });
                }

                return;

            }

            this.setState({
                hideVerified: true,
                hideLooksGood: true,
                linkValid: false
            });

        });
    }

    componentDidMount() {
    var customer_email="";
   /* document.getElementById('listenerFrame').onload = function() {
        var domain = 'https://checkout.na1.netsuite.com';
        var iframe = document.getElementById('listenerFrame').contentWindow;
        var times = 0;
        var inty = setInterval(function(){
            var message = 'Hello!  The time is: ' + (new Date().getTime());
            iframe.postMessage(message,domain);
            if(++times == 1) { clearInterval(inty); }
        },100);


        //listen to https://checkout.na1.netsuite.com back 
        window.addEventListener('message',function(event) {
            if(event.origin !== 'https://checkout.na1.netsuite.com') return;
            var data = event.data;
            customer_email = data.customer_email.email; //We receive customer_email from NS ERP.
            console.log(customer_email)
            config.setVerifiedEmail(customer_email);

        });

    }*/
        if(this.qs.key === null || this.qs.key === undefined || this.qs.key === '')
	    {
        this.setState ({
            showActivationCode : true,
            hideVerified: true,
            hideLooksGood: true,
            linkValid: true,
            showActivation: false
        })
	    //	window.open("/standard-activation","_self");
        } else {

        setTimeout(() => {
            this.validateActivationKey(customer_email)

        }, 1000);
        }
    }

    render() {

        if (this.state.alreadyConsumed) {
            return <Redirect to={'key-consumed?key=' + this.qs.key} push />;
        }

        // if (this.state.keyReady) {
        //     return <Redirect to={'key-ready?key=' + this.qs.key} />;
        // }

        if (this.state.showActivation) {
            return <Redirect to={'activate?key=' + this.qs.key} push />;
        }

        return (
            <div className="wrapper active-wrapper">

                <div className="loader" style={{ display: this.state.hideVerified === false ? 'block' : 'none' }}>
                    <div className="validate process text-center">
                        <div className="spinner mb-4">
                            <i className="fa fa-spinner fa-4x" aria-hidden="true"></i>
                        </div>
                        <h2>Validating Purchase</h2>
                    </div>
                </div>

                <div className="validated" style={{ display: this.state.hideLooksGood === false ? 'block' : 'none' }}>
                    <div className="checked process text-center">
                        <div className="mb-4">
                            <i className="fa fa-thumbs-o-up fa-4x" aria-hidden="true"></i>
                        </div>
                        <h2>Looks Good</h2>
                    </div>
                </div>

                <Header />
                <section className="content" style={{ display: this.state.showActivationCode === true ? 'block' : 'none'}}>
                <div className="container-fluid">
                <div className="row row-col">

                <div className="col-md-7 col">
                <div className="section-02"> 
        <h1 className="heading mb-4">Activate <br />  {/*<span className="smallhd-txt"><img src="images/smallHD-logo-txt.png" alt="logo"/></span>*/} <span className="os3-img">{/*<img src="https://www.smallhd.com/img/uploads/CINE7_KF_LG_os3.jpg" alt="OS3"/>*/} PageOS 4</span><span className="badge badge-dark">Free</span></h1>                                                  
                <ul className="subheading">
                    <li>Activating here registers your warranty.</li>
                    <li>Signs you up for firmware updates (optional).</li>
                    <li>Easy customer support interaction.</li>
                </ul>
                <a className="btn btn-primary btn-lg text-center mt-5 pr-5 pl-5" href="https://activate.smallhd.com/standard-activation">Activate</a>
                <div className="d-block mt-3">
                    <a href="https://www.smallhd.com/community/os3" target="_blank" className="link" data-container="body" data-toggle="popover" data-placement="left" data-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
                    <i className="icon fa fa-question-circle mr-2"  aria-hidden="true"></i>Know more about SmallHD OS3.
                    </a>
                    </div>
                </div>
                </div>
                <span className="or">OR</span>
                <div className="col-md-5 col">
                <div className="form">
                <h1 className="heading mb-4">Activate <br /> Camera Control</h1>
                <h2 className="subheading mb-4">Activate Camera Control upgrade on your compatible SmallHD monitor for Arri Amira, Arri Alexa mini and RED DSMC2 Cameras.</h2>
                 <fieldset className={this.state.licenseValid}>
                    <h3 className="mb-3">Activation Code</h3>
                    <div className="input-group input-group-lg">
                    <InputMask id="activationCodeInput" className={'form-control ' + this.state.activationCodeValid === false ? ' form-control text-uppercase' : 'text-uppercase rounded-right form-control ' + ' ' + this.state.activationCodeInputClass} type="text" placeholder="..." mask='****-****-****-****' value={this.state.activationCode} onChange={this.handleActivationCodeChange} />
                    <div className="input-group-append">
                    <button style={{ display: this.state.activationCodeValid === true ? 'block' : 'none' }}  onClick={this.handleActivationCodeSubmitBtn} className="btn btn-primary rounded-right" type="button">Go</button>
                    <button id="clearSerial" style={{ display: this.state.activationCodeValid === false ? 'block' : 'none' }} onClick={this.retryBtn} className="btn btn-danger" type="button"><i className="fa fa-times"></i></button>
                
                    </div>                    
                    </div>
                    <div className="d-block mt-3">
                    <a href="https://store.smallhd.com/arri-control-software" target="_blank" className="link"  data-container="body" data-toggle="popover" data-placement="left" data-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
                    <i className="icon fa fa-question-circle mr-2"  aria-hidden="true"></i>Know more about Camera Control.
                    </a>
                    </div>
                    <p style={{ display: this.state.activationCodeValid === false ? 'block' : 'none' }} className="mt-3 small">The activation code does not look valid</p>
                </fieldset>
                </div>
                </div>
                </div>                 
                </div>
                </section>
                <InvalidLink linkValid={this.state.linkValid} />


            </div>
        );
    }
}

export default Home;
